import { Skeleton } from '@mui/material';
import { FC } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { AiTranscriptSectionSkeleton } from '../../shared/ai-transcript/ai-transcript-section.skeleton';
import { AppointmentDetailsSectionSkeleton } from '../../shared/appointment-details/appointment-details-section.skeleton';
import { NotesSectionSkeleton } from '../../shared/notes-section/notes-section.skeleton';
import { PmsStatusSectionSkeleton } from '../../shared/pms-status/pms-status-section.skeleton';
import { Page, PageContent, PageTitle, Toolbar } from '../styles';
import { PatientDetailsSectionSkeleton } from './sections/patient-details/patient-details-section.skeleton';

export const CancellationRequestViewSkeleton: FC = () => (
  <Page>
    <PageTitle>Cancellation Request</PageTitle>
    <PageContent sx={{ margin: '0' }}>
      <Scrollbars autoHide>
        <PatientDetailsSectionSkeleton />
        <AppointmentDetailsSectionSkeleton />
        <AiTranscriptSectionSkeleton />
        <PmsStatusSectionSkeleton />
        <NotesSectionSkeleton />
      </Scrollbars>
      <Toolbar sx={{ flexDirection: 'column', borderTop: 'none' }}>
        <Skeleton variant="rounded" height={36} sx={{ marginBottom: '15px' }} />
        <Skeleton variant="rounded" height={36} />
      </Toolbar>
    </PageContent>
  </Page>
);
